import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0e50332"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-access-statistics-page" }
const _hoisted_2 = { class: "live-access-statistics-page__consumer" }

import { computed, onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import { Download } from '@element-plus/icons-vue'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import { usePermission } from '@/hooks/usePermission'
import type { CrudSort } from '@/types/crud'
import type { CrudSelectOption } from '@/types/crud-config'
import {
  createLiveAccessStatisticsSearchItems,
  liveAccessStatisticsTableColumns
} from './live-access-statistics.config'
import {
  exportLiveAccessStatistics,
  fetchLiveAccessStatisticsFilterOptions,
  fetchLiveAccessStatisticsPage
} from './live-access-statistics.service'
import type { LiveAccessStatisticsFilters } from './live-access-statistics.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveAccessStatistics',
  setup(__props) {

const canList = usePermission('liveAccessStatistics', 'list')
const canDownload = usePermission('liveAccessStatistics', 'download')

function createFilters(): LiveAccessStatisticsFilters {
  return {
    channelId: '',
    consumerNickName: '',
    watchTotalTime: '',
    accessTime: [
      dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ]
  }
}

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  lastSuccessfulQuery,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  changeSort,
  refresh
} = usePagedCrud({
  createFilters,
  fetchPage: fetchLiveAccessStatisticsPage
})

const channelOptions = ref<CrudSelectOption[]>([])
const optionsLoading = ref(false)
const exporting = ref(false)

const searchItems = computed(() =>
  createLiveAccessStatisticsSearchItems(
    channelOptions.value,
    optionsLoading.value
  )
)
const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

function runQuery(action: () => Promise<boolean>) {
  return canList ? action() : Promise.resolve(false)
}

function handleSortChange(value: {
  prop?: string
  order?: 'ascending' | 'descending' | null
}) {
  const sort: CrudSort | undefined =
    value.prop && value.order
      ? { prop: value.prop, order: value.order }
      : undefined
  return runQuery(() => changeSort(sort))
}

async function loadFilterOptions() {
  optionsLoading.value = true
  try {
    const channels = await fetchLiveAccessStatisticsFilterOptions()
    channelOptions.value = channels.map((item) => ({
      label: item.eventName,
      value: item.rowId
    }))
  } catch (cause) {
    ElMessage.error(
      cause instanceof Error ? cause.message : '直播间选项加载失败，请稍后重试'
    )
  } finally {
    optionsLoading.value = false
  }
}

function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

async function download() {
  if (!lastSuccessfulQuery.value) return

  exporting.value = true
  try {
    saveBlob(
      await exportLiveAccessStatistics(lastSuccessfulQuery.value),
      '直播间观看统计.xlsx'
    )
  } catch (cause) {
    ElMessage.error(cause instanceof Error ? cause.message : '导出失败')
  } finally {
    exporting.value = false
  }
}

onMounted(() => {
  loadFilterOptions()
  runQuery(load)
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: searchItems.value,
      loading: _unref(loading),
      onSearch: _cache[0] || (_cache[0] = ($event: any) => (runQuery(_unref(search)))),
      onReset: _cache[1] || (_cache[1] = ($event: any) => (runQuery(_unref(reset))))
    }, null, 8, ["model", "items", "loading"]),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      columns: _unref(liveAccessStatisticsTableColumns),
      onPageChange: _cache[2] || (_cache[2] = ($event: any) => (runQuery(() => _unref(changePage)($event)))),
      onPageSizeChange: _cache[3] || (_cache[3] = ($event: any) => (runQuery(() => _unref(changePageSize)($event)))),
      onSortChange: handleSortChange,
      onRetry: _cache[4] || (_cache[4] = ($event: any) => (runQuery(_unref(refresh))))
    }, {
      title: _withCtx(() => [
        _createTextVNode("访问记录")
      ]),
      actions: _withCtx(() => [
        (_unref(canDownload))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: exporting.value,
              disabled: !_unref(lastSuccessfulQuery),
              onClick: download
            }, {
              default: _withCtx(() => [
                (!exporting.value)
                  ? (_openBlock(), _createBlock(_unref(Download), {
                      key: 0,
                      class: "live-access-statistics-page__button-icon",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(" 下载 ")
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      consumer: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 60,
            src: row.consumerHeadImgUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", null, _toDisplayString(row.consumerNickName), 1)
        ])
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "columns"])
  ]))
}
}

})